import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { UtilsProvider } from 'src/commons/utils';
import * as moment from "moment";
import { MatDialog } from '@angular/material';
import { FormBuilder, FormControl, Validators } from '@angular/forms';


@Component({
	selector: "export-files",
	templateUrl: "./export-files.component.html",
	styleUrls: ["./export-files.component.scss"]
})
export class ExportFilesComponent implements OnInit {

    public exportOptionsForm: any;
    private exportOptions: Object[] = [
		{ value: false, text: 'Excel' },
		{ value: false, text: 'PDF' }
	];

    @Input() exportResult: Object[];
    @Input() fileName: string;

    constructor(
        private utils: UtilsProvider,
        public dialog: MatDialog,
        public formBuilder: FormBuilder,
    ){}

    ngOnInit() {
        this.initExportOptionsForm();
    }

    downloadExcel() {
		this.utils.exportAsExcelFile(this.exportResult, this.fileName + '-' + moment().format("YYYY-MM-DD"));
	}

	downloadPDF() {
		let cols = [];
		let rows = [];

		for(const col in this.exportResult[0]) {
			cols.push(col);
		}

		for(const elements of this.exportResult) {
			const tempRow = [];
			for(const row in cols) {
				tempRow.push(elements[cols[row]]);
			}
			rows.push(tempRow);
		}

		this.utils.exportAsPDF(cols, rows, this.fileName + '-' + moment().format("YYYY-MM-DD"));
	}

	openDialog(dialog: TemplateRef<any>) {
		this.initExportOptionsForm();
		const dialogRef = this.dialog.open(dialog, { data: {} });
		dialogRef.afterClosed().subscribe(res => {
			this.exportOptions.forEach(el => el['value'] = false);
		});
	}

	initExportOptionsForm() {
		const self = this;
		const checkBoxList = new FormControl("", Validators.compose([Validators.required]));
		this.exportOptionsForm = [
			{
				fields: [
					{
						name: "checkBoxList",
						type: "checkbox",
						placeholder: "Selecione o(s) tipo(s) de arquivo para exportação",
						cols: "col-lg-12 col-md-12 col-sm-6",
						options: {
							fields: {
								value: "value",
								text: "text",
							},
							items: this.exportOptions
						},
						clickCallback(event) {
							const idx = self.exportOptions.findIndex(el => el['text'] === event['text']);
							self.exportOptions[idx]['value'] = !self.exportOptions[idx]['value'];
						}
					},
				],
				builder: this.formBuilder.group({ checkBoxList }),
				validation_messages: {
					checkBoxList: []
				}
			}
		];
	}

	async exportFiles() {
		if(!this.exportResult || this.exportResult.length === 0) {
			this.dialog.closeAll();
			return this.utils.toast({
				message: 'Este formulário não possui dados a serem exportados.',
				action: 'Ok',
				duration: 8000
			});
		}

		if(this.exportOptions[0]['value']) 
			await this.downloadExcel();
		
		if(this.exportOptions[1]['value'])
			await this.downloadPDF();

		this.dialog.closeAll();
	}

}